module.exports = __webpack_public_path__ + "img/gl-l.910925f2.png";